import { CampaignIsArchivedError } from '../../types'

export function campaignIsArchived(options: CampaignIsArchivedError) {
	;(options as any).isCampaignArchived = true
	if (options.throw) { throw options }
	return options
}

export function isCampaignArchived(obj: any): obj is CampaignIsArchivedError {
	return !!obj?.isCampaignArchived
}
